import type { SVGProps } from "react";
const SvgTriangleTransition = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 393 20" {...props}>
    <path d="M0 20V0h393z" />
  </svg>
);
export default SvgTriangleTransition;
